// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// ✅ مشروع yourname-13fab
const firebaseConfig = {
  apiKey: "AIzaSyAacSG1cMauYAxrDhDuNfMj4gN4mDOIEV0",
  authDomain: "coffeestation-b02f9.firebaseapp.com",
  projectId: "coffeestation-b02f9",
  storageBucket: "coffeestation-b02f9.firebasestorage.app",
  messagingSenderId: "19913038695",
  appId: "1:19913038695:web:2fe044ce013b1a59d6adc2",
  measurementId: "G-6Y4CN2H9ML"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
